import React from 'react';
import styled from 'styled-components';
import { TextareaAutosize as MuiTextareaAutosize } from '@mui/material';

const TextArea = (props) => {
  return <SMuiTextareaAutosize {...props} />;
};

const SMuiTextareaAutosize = styled(MuiTextareaAutosize)`
  && {
    background: ${({theme}) => theme.palette.colors.white};
    border: 0.5px solid ${({theme}) => theme.palette.colors.gray300};
    box-sizing: border-box;
    border-radius: 5px;
    width: 100%;
    min-height: 80px;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    color: ${({theme}) => theme.palette.colors.black100};
    padding: 5px 10px;
    &::placeholder {
      color: ${({theme}) => theme.palette.colors.gray300};
    }
    :hover {
      border-color: ${({theme}) => theme.palette.colors.black100};
    }
    :focus {
      border: 2px solid ${({theme}) => theme.palette.colors.blue100};
      padding: 10px 10px 0px;
    }
  }
`;

export default TextArea;
